import { render } from "./FooterFeature.vue?vue&type=template&id=1315b13e&scoped=true"
import script from "./FooterFeature.vue?vue&type=script&lang=js"
export * from "./FooterFeature.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "./FooterFeature.vue?vue&type=style&index=1&id=1315b13e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1315b13e"]])

export default __exports__